<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ACTIVITY_CREATED.SALES_ACTIVITY_CREATED' | translate }}
</span>

<glxy-form-field [required]="true">
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ACTIVITY_CREATED.ACTIVITY_TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="selectedActions" multiple="true">
    <mat-option *ngFor="let salespersonAction of salespersonActions" [value]="salespersonAction.id">
      {{ salespersonAction.label | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>

<glxy-form-field [required]="true">
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ACTIVITY_CREATED.CONNECTED' | translate }}
  </glxy-label>
  <mat-select [(value)]="selectedConnectionStatus" multiple="true">
    <mat-option *ngFor="let connectionStatus of connectedStatusOptions" [value]="connectionStatus.id">
      {{ connectionStatus.label | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
